import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Image } from 'react-bootstrap';
import './Login.css'; // Import your custom CSS file for additional styling

// Import JSON data
import usersData from '../Login/Users.json'; // Update the import path
import Addstu from './Addstu';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOTP] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newOTP, setNewOTP] = useState(''); // Define newOTP state variable
  const [verificationMethod, setVerificationMethod] = useState(''); // Define verification method state

  const handleLogin = (e) => {
    e.preventDefault();
    // Authentication logic here
    const user = usersData.find((user) => user.username === username && user.password === password);
    if (user) {
      setLoggedIn(true);
      alert('Login successful!');
    } else {
      alert('Invalid username or password!');
    }
  };

  const handleForgotPassword = () => {
    // Send OTP logic here (simulate sending OTP for demonstration)
    const user = usersData.find((user) => user.username === username);
    if (user) {
      setShowOTP(true);
      // Generate and send OTP (in real application, this would be sent via email or SMS)
      const generatedOTP = Math.floor(100000 + Math.random() * 900000); // Generate a 6-digit OTP
      alert(`OTP sent to ${user.username}: ${generatedOTP}`); // Simulated OTP sending
      // Save OTP for verification later
      setOTP(generatedOTP.toString());
      // Set the verification method here based on user preferences or system configurations
      setVerificationMethod(user.email ? 'email' : 'SMS');
    } else {
      alert('User not found!');
    }
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    if (otp === newOTP) { // Use newOTP state variable in the comparison
      // OTP verification successful, update password
      const updatedUsersData = usersData.map((user) => {
        if (user.username === username) {
          return { ...user, password: newPassword };
        }
        return user;
      });
      // Update the users.json file or database with the updatedUsersData
      fetch('path/to/your/api/endpoint', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedUsersData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Updated users data:', data);
          alert('Password updated successfully!');
          setShowOTP(false);
        })
        .catch((error) => {
          console.error('Error updating password:', error);
          alert('Error updating password. Please try again.');
        });
    } else {
      alert('Invalid OTP!');
    }
  };

  return (
    <div className="login-bg">
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} sm={8} md={6}>
            <Image src="path/to/your/logo.png" alt="Sahaj Public School Logo" className="school-logo" />
            {!loggedIn ? (
              <Form onSubmit={handleLogin} className="bg-light p-4 rounded">
                <Form.Group controlId="formBasicUsername">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                  Login
                </Button>

                <Button variant="link" onClick={handleForgotPassword} className="mt-2">
                  Forgot Password?
                </Button>
              </Form>
            ) : (
              <div className="bg-light p-4 rounded">

                <h2 className="text-center mb-4 fade-in">Welcome, {username}!</h2>
                {/* Add other content for logged-in users */}

               <Addstu/>
                
              </div>
            )}
            {showOTP && !loggedIn && (
              <Form onSubmit={handleVerifyOTP} className="bg-light p-4 rounded mt-3">
                <Form.Group controlId="formBasicOTP">
                  <Form.Label>Enter OTP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOTP(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicNewPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicNewOTP">
                  <Form.Label>New OTP</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter new OTP"
                    value={newOTP}
                    onChange={(e) => setNewOTP(e.target.value)}
                  />
                </Form.Group>

                {/* Display the verification method */}
                <p>Verification Method: {verificationMethod}</p>

                <Button variant="primary" type="submit" className="w-100">
                  Verify OTP and Reset Password
                </Button>
              </Form>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
